// extracted by mini-css-extract-plugin
export default {"container":"AuthLayout_container__t1yea","rightSide":"AuthLayout_rightSide__+el2R","leftSide":"AuthLayout_leftSide__x0lF0","crystal":"AuthLayout_crystal__3geCp"};